import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// tslint:disable-next-line: import-blacklist
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../user.service';
import { NGaugeService } from './ngauge.service';
import { AuthService } from './auth.service';

@Injectable()
export class NotesService {

  refreshCountSub = new BehaviorSubject<any>(null);
  refreshCountObs = this.refreshCountSub.asObservable();

  constructor(
    private httpClient: HttpClient,
    private userService: UserService,
    private authService: AuthService,
    private ngaugeService: NGaugeService) { }

  refreshAlertCount(value) {
    this.refreshCountSub.next(value);
  }

  getNotes(currentDate) {
    const userId = this.userService.getLoggedInUserId();
    const SID = this.authService.getSID()
    const filter = '?currentDate=' + currentDate + '&userId=' + userId + '&SID=' + SID;
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_NOTES_URL') + filter);
  }

  getReportNotification(userId) {
    let whereFilter:any=null;
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if(this.userService.getLoggedInUserProperty()=="Yedla Management Company" && user.userType=="SuperAdmin"){
      whereFilter = '"where": {"and": [{"userId": "' + userId + '"}, {"status":"notread"}]}';
    }
    else{
      whereFilter = '"where": {"and": [{"userId": "' + userId + '"}, {"status":"notread"}, {"SID":"'+this.authService.getSID()+'"}]}';

    }
    const orderBy = '"order":"id desc"';
    const FILTER = '{' + whereFilter + ',' + orderBy + '}';
    const params = { params: this.ngaugeService.getHttpParams(FILTER) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_NOTIFICATION'), params);
  }
  // getReportNotification(userId) {
  //   const whereFilter = '"where": {"and": [{"userId": "' + userId + '"}, {"status":"notread"}]}';
  //   const orderBy = '"order":"id desc"';
  //   const FILTER = '{' + whereFilter + ',' + orderBy + '}';
  //   const params = { params: this.ngaugeService.getHttpParams(FILTER) };
  //   return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_NOTIFICATION'), params);
  // }

  getReportedIssues() {
    const orderBy = '"order":"updatedOn asc"';
    const columnFilter = '"fields": ["id", "status", "about", "updatedOn", "createdOn","SID"]';
    const whereCondition = '"where": {"or": [{"status":"New"}, {"status": "Open"}]}';
    const filter = '{' + whereCondition + ',' + columnFilter + ',' + orderBy + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_REPORT_ISSUE'), params);
  }

  getSuggestEnhancements() {
    const orderBy = '"order":"updatedOn asc"';
    const columnFilter = '"fields": ["id", "status", "about", "updatedOn", "createdOn","SID"]';
    const whereCondition = '"where": {"or": [{"status":"New"}, {"status": "Submitted"}]}';
    const filter = '{' + whereCondition + ',' + columnFilter + ',' + orderBy + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('SUGGEST_ENHANCEMENT'), params);
  }

  getNotifications() {
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_NOTIFICATIONS'));
  }

  getLastFiveWeeksNotification(date) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('GET_LAST_FIVE_WEEKS_NOTIFICATION'), { currentDate: date,SID : this.authService.getSID() });
  }

  searchNotifications(fromDate, toDate, id) {
    const params = {
      startDate: fromDate,
      endDate: toDate,
      salesPerson: id
    };
    return this.httpClient.post(this.ngaugeService.getMeldURL('SEARCH_NOTIFICATION'), params);
  }

  updateNotification(id) {
    const value = { id, status: 'read' };
    return this.httpClient.put(this.ngaugeService.getMeldURL('GET_REPORT_NOTIFICATION') + '/' + id, value);
  }

  updateAlert(id) {
    const value = { id, status: 'read' };
    return this.httpClient.put(this.ngaugeService.getMeldURL('NOTES') + '/' + id, value);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/notes.service.ts